import { IAppConfigurationProvider } from "@dirootie-core/core-types";
import { IAppModule, IServiceProvider } from "./modules.types";
import { Dispatcher, handlersFactory } from "@dirootie-web/elements-types";
import { ILogger } from '@dirootie-logging/logging-types';
import { SessionStore } from "@dirootie-domain/iam";

export class DispatcherModule implements IAppModule {
  name:string = 'Dispatcher';

  configureServices(
    serviceProvider: IServiceProvider,
    configurationProvider: IAppConfigurationProvider
  ): void {
    const handlers = handlersFactory(serviceProvider);
    const dispatcher = new Dispatcher(
      serviceProvider.resolve<ILogger>('logger')
    );
    handlers.forEach((x) => {
      dispatcher.register(x[1], { handle: x[0] });
    });
    serviceProvider.register('dispatcher', dispatcher);
    const sessionStore = new SessionStore(dispatcher);
    serviceProvider.register('session-store', sessionStore);
  }
}
